import getByVariantIdDeepProductSelector from 'modules/product/redux/selectors/get-by-variant-id-deep'

const getByVariantIdsProductsSelector = (variants = []) => state => {
  return variants.reduce((acc, variant) => {
    const variantId = variant.id
    acc[variantId] = getByVariantIdDeepProductSelector(variantId)(state)
    return acc
  }, {})
}

export default getByVariantIdsProductsSelector
